var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputNumber',{staticStyle:{"width":"100%"},attrs:{"max":_vm.attrs.max||Infinity,"min":_vm.attrs.min||-Infinity,"value":_vm.bindValue,"placeholder":_vm.attrs.placeholder || '请输入数字'},on:{"input":_vm.onInput}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c69d330","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../projectCore/src/components/input-number/src/index.vue
// module id = null
// module chunks = 